export enum spectoCalendarTranslations {
  linkEmployerDashboard = 'spectoCalendarTranslations.linkEmployerDashboard',
  linkInterviewInvitation = 'spectoCalendarTranslations.linkInterviewInvitation',
  linkSearchCandidates = 'spectoCalendarTranslations.linkSearchCandidates',
  linkCandidateDashboard = 'spectoCalendarTranslations.linkCandidateDashboard',
  linkAllRequests = 'spectoCalendarTranslations.linkAllRequests',
  linkEditCV = 'spectoCalendarTranslations.linkEditCV',
}
